/* eslint-disable boundaries/no-unknown */
import { Component, inject, OnInit } from '@angular/core';
import { ChildrenOutletContexts, RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { PrimeNG } from 'primeng/config';
import { CommonModule } from '@angular/common';
import { LoadingToastComponent } from 'libs/ui/src/public-api';
import en from './../../public/i18n/en.json';
import sr from './../../public/i18n/sr.json';
import cyr from './../../public/i18n/cyr.json';

import { APP_CONSTANTS } from 'libs/core/src/lib/constants/constants';
import {
  ENVIRONMENT,
  Environment,
} from 'libs/core/src/lib/config/environment-config';
import { en as enPrimeng } from 'libs/core/src/lib/i18n/primeng-locale/en';
import { sr as srPrimeng } from 'libs/core/src/lib/i18n/primeng-locale/sr';
import { cyr as cyrPrimeng } from 'libs/core/src/lib/i18n/primeng-locale/cyr';

@Component({
  selector: 'app-root',
  imports: [
    CommonModule,
    RouterOutlet,
    ButtonModule,
    ToastModule,
    LoadingToastComponent,
  ],
  template: `
    <router-outlet></router-outlet>

    <p-toast [life]="4500" position="bottom-right" key="br"></p-toast>
    <p-toast [life]="4500" position="bottom-right" key="br-warn"></p-toast>
    <p-toast [life]="4500" position="bottom-right" key="br-error"></p-toast>

    <lib-loading-toast></lib-loading-toast>
  `,
})
export class AppComponent implements OnInit {
  private translate = inject(TranslateService);
  private primeNG = inject(PrimeNG);
  private contexts = inject(ChildrenOutletContexts);
  private environment = inject<Environment>(ENVIRONMENT);

  ngOnInit() {
    this.translate.setTranslation('en', en);
    this.translate.setTranslation('sr', sr);
    this.translate.setTranslation('cyr', cyr);
    this.translate.setFallbackLang('sr');

    let lang = localStorage.getItem(this.environment.STORAGE.language);

    const primengLanguages: Record<string, any> = {
      en: enPrimeng,
      sr: srPrimeng,
      cyr: cyrPrimeng,
    };

    if (!lang || !APP_CONSTANTS.LANGUAGES.includes(lang)) {
      lang = APP_CONSTANTS.DEFAULT_LANGUAGE;
      localStorage.setItem(this.environment.STORAGE.language, lang);
    }

    this.translate.use(lang);
    this.primeNG.setTranslation(primengLanguages[lang]);
  }
}
